import { useEffect, useState } from "react";
import { api } from "./api";

let cache = null;
const listeners = new Set();

export const reloadHoliday = () => {
  cache = api.get("/holiday").then((r) => r.data).catch(() => ({ active: "none" }));
  cache.then((d) => listeners.forEach((fn) => fn(d)));
  return cache;
};

// Active holiday theme (or { active: "none" }), fetched once and shared.
export const useHoliday = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    listeners.add(setData);
    (cache || reloadHoliday()).then(setData);
    return () => listeners.delete(setData);
  }, []);
  return data && data.active !== "none" ? data : null;
};

export const THEME_STYLE = {
  thanksgiving: {
    bar: "bg-[#7a3b12] text-[#fde9c8]",
    accent: "#d9822b",
    accentText: "text-[#d9822b]",
    button: "bg-[#c2621b] hover:bg-[#7a3b12] text-white",
    soft: "bg-[#fdf1e3]",
    particles: ["#c2621b", "#d9822b", "#a3461a"],
  },
  christmas: {
    bar: "bg-[#14532d] text-[#fef3c7]",
    accent: "#b91c1c",
    accentText: "text-[#b91c1c]",
    button: "bg-[#b91c1c] hover:bg-[#14532d] text-white",
    soft: "bg-[#fdf2f2]",
    particles: ["#7aa7c7", "#94a3b8", "#9fc3dd"],
  },
};
